import { createFileRoute } from '@tanstack/react-router';

import { EmailTasks } from '../modules/EmailTasks';

export const Route = createFileRoute('/admin/email-tasks')({
  component: RouteComponent,
  head() {
    return {
      meta: [{ title: 'Email Tasks Admin' }],
    };
  },
});

function RouteComponent() {
  return <EmailTasks />;
}
